import BuyersBlock from './buyers-block';
export default BuyersBlock